export default __webpack_public_path__ + "static/media/b-13.248455ae.png";